import { BadgeClass } from './css-badge-classes';

export const UrgentBadges = { stroke: 'stroke', trauma: 'polytrauma' };

export const ClassToDisplayMapping = new Map<string, string>([
    [BadgeClass.Stroke, 'Stroke'],
    [BadgeClass.Trauma, 'Polytrauma'],
    [BadgeClass.Approved, 'Approved'],
    [BadgeClass.MissingClinicalHistory, 'Missing clinical history'],
    [BadgeClass.MissingDocumentation, 'Missing Documentation'],
    [BadgeClass.MissingImages, 'Missing Images'],
    [BadgeClass.MissingPriorReport, 'Missing Prior Report'],
    [BadgeClass.MissingPriorImages, 'Missing Prior Images'],
    [BadgeClass.ReviewOrderDetails, 'Review Order Details'],
    [BadgeClass.AwaitingFurtherDetails, 'Awaiting Further Details'],
    [BadgeClass.TransferringImages, 'Transferring Images'],
    [BadgeClass.ReadyToReport, 'Ready To Report'],
    [BadgeClass.Reporting, 'Reporting'],
    [BadgeClass.Reported, 'Reported'],
    [BadgeClass.Cancelled, 'Cancelled'],
    [BadgeClass.Declined, 'Declined'],
    [BadgeClass.AwaitingAssignment, 'Awaiting Assignment'],
    [BadgeClass.AwaitingDecision, 'Awaiting Decision'],
    [BadgeClass.ReviewReferralDetails, 'Review Referral Details'],
    [BadgeClass.AwaitingFollowUp, 'Awaiting Follow Up'],
    [BadgeClass.AwaitingAcknowledgement, 'Awaiting Acknowledgement'],
    [BadgeClass.Acknowledged, 'Acknowledged'],
    [BadgeClass.ClinicalDiscussionRequired, 'Needs Clinical Discussion'],
    [BadgeClass.Deferred, 'Deferred']
]);
